import { api, apiCall } from './client'
import type {
  ApiResponse,
  Appointment,
  CreateAppointmentData,
  PaginatedData,
  UpdateAppointmentData,
} from '../../types'

export type AppointmentListParams = {
  page?: number
  limit?: number
  sortBy?: string
  sortOrder?: 'ASC' | 'DESC'
  patientId?: number
  startDate?: string
  endDate?: string
}

export const appointmentsService = {
  async list(
    params?: AppointmentListParams
  ): Promise<ApiResponse<PaginatedData<Appointment>>> {
    return apiCall(
      api.get<ApiResponse<PaginatedData<Appointment>>>('/appointments', {
        params,
      })
    )
  },

  async getById(id: number): Promise<ApiResponse<Appointment>> {
    return apiCall(api.get<ApiResponse<Appointment>>(`/appointments/${id}`))
  },

  async create(
    payload: CreateAppointmentData
  ): Promise<ApiResponse<Appointment>> {
    return apiCall(api.post<ApiResponse<Appointment>>('/appointments', payload))
  },

  async update(
    id: number,
    payload: UpdateAppointmentData
  ): Promise<ApiResponse<Appointment>> {
    return apiCall(
      api.put<ApiResponse<Appointment>>(`/appointments/${id}`, payload)
    )
  },

  async delete(id: number): Promise<ApiResponse<void>> {
    return apiCall(api.delete<ApiResponse<void>>(`/appointments/${id}`))
  },

  async getByPatientId(
    patientId: number,
    params?: Omit<AppointmentListParams, 'patientId'>
  ): Promise<ApiResponse<PaginatedData<Appointment>>> {
    return apiCall(
      api.get<ApiResponse<PaginatedData<Appointment>>>(
        `/appointments/patient/${patientId}`,
        { params }
      )
    )
  },
}

export type AppointmentService = typeof appointmentsService
